import React from "react";

const InventoryMenuIcon = ({ width, height, color }) => {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.4218 0H4.5551C2.00564 0 0 2.06539 0 4.69596V27.259C0 29.8896 2.00564 32 4.5551 32H26.4218C28.9713 32 31 29.8896 31 27.259V4.69596C31 2.06539 28.9713 0 26.4218 0ZM28.3679 27.259C28.3679 28.3422 27.4716 29.2237 26.4218 29.2237H4.5551C3.50534 29.2237 2.63208 28.3422 2.63208 27.259V4.69596C2.63208 3.61279 3.50534 2.77626 4.5551 2.77626H26.4218C27.4716 2.77626 28.3679 3.61279 28.3679 4.69596V27.259Z"
        fill="white"
      />
      <path
        d="M23.095 13.9482H12.7999C12.0385 13.9482 11.4211 14.6732 11.4211 15.5893C11.4211 16.5053 12.0383 17.2303 12.7999 17.2303H23.095C23.8564 17.2303 24.4738 16.5053 24.4738 15.5893C24.4738 14.6732 23.8564 13.9482 23.095 13.9482Z"
        fill="white"
      />
      <path
        d="M23.095 8.20508H12.7999C12.0385 8.20508 11.4211 8.93007 11.4211 9.8461C11.4211 10.7621 12.0383 11.4871 12.7999 11.4871H23.095C23.8564 11.4871 24.4738 10.7621 24.4738 9.8461C24.4738 8.93007 23.8564 8.20508 23.095 8.20508Z"
        fill="white"
      />
      <path
        d="M23.095 19.6929H12.7999C12.0385 19.6929 11.4211 20.4179 11.4211 21.3339C11.4211 22.2499 12.0383 22.9749 12.7999 22.9749H23.095C23.8564 22.9749 24.4738 22.2499 24.4738 21.3339C24.4738 20.4179 23.8564 19.6929 23.095 19.6929Z"
        fill="white"
      />
      <path
        d="M8.15795 22.9749C9.05904 22.9749 9.78953 22.2402 9.78953 21.3339C9.78953 20.4276 9.05904 19.6929 8.15795 19.6929C7.25685 19.6929 6.52637 20.4276 6.52637 21.3339C6.52637 22.2402 7.25685 22.9749 8.15795 22.9749Z"
        fill="white"
      />
      <path
        d="M8.15795 17.2303C9.05904 17.2303 9.78953 16.4956 9.78953 15.5893C9.78953 14.683 9.05904 13.9482 8.15795 13.9482C7.25685 13.9482 6.52637 14.683 6.52637 15.5893C6.52637 16.4956 7.25685 17.2303 8.15795 17.2303Z"
        fill="white"
      />
      <path
        d="M8.15795 11.4871C9.05904 11.4871 9.78953 10.7524 9.78953 9.8461C9.78953 8.93979 9.05904 8.20508 8.15795 8.20508C7.25685 8.20508 6.52637 8.93979 6.52637 9.8461C6.52637 10.7524 7.25685 11.4871 8.15795 11.4871Z"
        fill="white"
      />
    </svg>
  );
};

export default InventoryMenuIcon;
